$(document).ready(function () {
  const grid = document.querySelector('.desk_frames-grid');
  if (!grid) return;

  const outer = grid.closest('.desk_frames-grid__outer');
  const prevBtn = outer.querySelector('.desk_frames-swiper-button-prev');
  const nextBtn = outer.querySelector('.desk_frames-swiper-button-next');

  function getSlides() {
    return Array.from(grid.querySelectorAll('.desk_frames-cell'));
  }

  function slideTarget(slide) {
    return Math.max(0, slide.offsetLeft - 16);
  }

  function updateArrows() {
    const scrollLeft = Math.round(grid.scrollLeft);
    const maxScroll = Math.round(grid.scrollWidth - grid.clientWidth);
    prevBtn.classList.toggle('disabled', scrollLeft <= 2);
    nextBtn.classList.toggle('disabled', maxScroll <= 2 || scrollLeft >= maxScroll - 2);
  }

  function getNextSlide() {
    const scrollLeft = grid.scrollLeft;
    const all = getSlides();
    const idx = all.findIndex(s => s.offsetLeft >= scrollLeft - 2);
    if (idx === -1 || idx + 1 >= all.length) return null;
    return all[idx + 1];
  }

  function getPrevSlide() {
    const scrollLeft = grid.scrollLeft;
    const all = getSlides();
    const idx = all.findIndex(s => s.offsetLeft >= scrollLeft - 2);
    return idx <= 0 ? all[0] : all[idx - 1];
  }

  function snapToNearest() {
    const scrollLeft = grid.scrollLeft;
    const all = getSlides();
    let best = all[0];
    let bestDiff = Infinity;
    all.forEach(s => {
      const diff = Math.abs(slideTarget(s) - scrollLeft);
      if (diff < bestDiff) { bestDiff = diff; best = s; }
    });
    grid.scrollTo({ left: slideTarget(best), behavior: 'smooth' });
  }

  nextBtn.addEventListener('click', () => {
    const slide = getNextSlide();
    if (slide) grid.scrollTo({ left: slideTarget(slide), behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    const slide = getPrevSlide();
    if (slide) grid.scrollTo({ left: slideTarget(slide), behavior: 'smooth' });
  });

  grid.addEventListener('scroll', updateArrows);
  new ResizeObserver(updateArrows).observe(grid);

  // Mouse drag
  let isDown = false, startX, startScroll, hasDragged = false;

  grid.addEventListener('mousedown', e => {
    if (e.target.closest('.desk_frames-swiper-button')) return;
    isDown = true;
    hasDragged = false;
    startX = e.pageX;
    startScroll = grid.scrollLeft;
    grid.style.cursor = 'grabbing';
  });

  grid.addEventListener('dragstart', e => e.preventDefault());

  document.addEventListener('mousemove', e => {
    if (!isDown) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 5) hasDragged = true;
    grid.scrollLeft = startScroll - dx;
  });

  document.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    grid.style.cursor = '';
    if (hasDragged) snapToNearest();
    hasDragged = false;
  });

  // Touch: snap to nearest slide after finger lift
  grid.addEventListener('touchend', snapToNearest, { passive: true });

  updateArrows();

  // Video playback
  const section = grid.closest('.desk_frames');
  const videos = section ? Array.from(section.querySelectorAll('.desk_frames-cell-video')) : [];

  if (videos.length > 0) {
    let endedCount = 0;

    function playAll() {
      endedCount = 0;
      videos.forEach(v => {
        v.currentTime = 0;
        v.play().catch(() => {});
      });
    }

    videos.forEach(v => {
      v.addEventListener('ended', () => {
        endedCount++;
        if (endedCount >= videos.length) playAll();
      });
    });

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        playAll();
      } else {
        videos.forEach(v => v.pause());
      }
    }, { threshold: 0.2 });

    observer.observe(section);
  }
});

$(document).ready(function () {
  const grid = document.querySelector('.desk_frames-grid');
  if (!grid) return;

  const outer = grid.closest('.desk_frames-grid__outer');
  const prevBtn = outer.querySelector('.desk_frames-swiper-button-prev');
  const nextBtn = outer.querySelector('.desk_frames-swiper-button-next');

  function getSlides() {
    return Array.from(grid.querySelectorAll('.desk_frames-cell'));
  }

  function slideTarget(slide) {
    return Math.max(0, slide.offsetLeft - 16);
  }

  function updateArrows() {
    const scrollLeft = Math.round(grid.scrollLeft);
    const maxScroll = Math.round(grid.scrollWidth - grid.clientWidth);
    prevBtn.classList.toggle('disabled', scrollLeft <= 2);
    nextBtn.classList.toggle('disabled', maxScroll <= 2 || scrollLeft >= maxScroll - 2);
  }

  function getNextSlide() {
    const scrollLeft = grid.scrollLeft;
    const all = getSlides();
    const idx = all.findIndex(s => s.offsetLeft >= scrollLeft - 2);
    if (idx === -1 || idx + 1 >= all.length) return null;
    return all[idx + 1];
  }

  function getPrevSlide() {
    const scrollLeft = grid.scrollLeft;
    const all = getSlides();
    const idx = all.findIndex(s => s.offsetLeft >= scrollLeft - 2);
    return idx <= 0 ? all[0] : all[idx - 1];
  }

  function snapToNearest() {
    const scrollLeft = grid.scrollLeft;
    const all = getSlides();
    let best = all[0];
    let bestDiff = Infinity;
    all.forEach(s => {
      const diff = Math.abs(slideTarget(s) - scrollLeft);
      if (diff < bestDiff) { bestDiff = diff; best = s; }
    });
    grid.scrollTo({ left: slideTarget(best), behavior: 'smooth' });
  }

  nextBtn.addEventListener('click', () => {
    const slide = getNextSlide();
    if (slide) grid.scrollTo({ left: slideTarget(slide), behavior: 'smooth' });
  });

  prevBtn.addEventListener('click', () => {
    const slide = getPrevSlide();
    if (slide) grid.scrollTo({ left: slideTarget(slide), behavior: 'smooth' });
  });

  grid.addEventListener('scroll', updateArrows);
  new ResizeObserver(updateArrows).observe(grid);

  // Mouse drag
  let isDown = false, startX, startScroll, hasDragged = false;

  grid.addEventListener('mousedown', e => {
    if (e.target.closest('.desk_frames-swiper-button')) return;
    isDown = true;
    hasDragged = false;
    startX = e.pageX;
    startScroll = grid.scrollLeft;
    grid.style.cursor = 'grabbing';
  });

  grid.addEventListener('dragstart', e => e.preventDefault());

  document.addEventListener('mousemove', e => {
    if (!isDown) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 5) hasDragged = true;
    grid.scrollLeft = startScroll - dx;
  });

  document.addEventListener('mouseup', () => {
    if (!isDown) return;
    isDown = false;
    grid.style.cursor = '';
    if (hasDragged) snapToNearest();
    hasDragged = false;
  });

  // Touch: snap to nearest slide after finger lift
  grid.addEventListener('touchend', snapToNearest, { passive: true });

  updateArrows();

  // Video playback
  const section = grid.closest('.desk_frames');
  const videos = section ? Array.from(section.querySelectorAll('.desk_frames-cell-video')) : [];

  if (videos.length > 0) {
    let endedCount = 0;

    function playAll() {
      endedCount = 0;
      videos.forEach(v => {
        v.currentTime = 0;
        v.play().catch(() => {});
      });
    }

    videos.forEach(v => {
      v.addEventListener('ended', () => {
        endedCount++;
        if (endedCount >= videos.length) playAll();
      });
    });

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        playAll();
      } else {
        videos.forEach(v => v.pause());
      }
    }, { threshold: 0.2 });

    observer.observe(section);
  }
});
